import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16.2812 13.6096C15.1512 14.7396 13.5312 15.0896 12.1012 14.6396L9.51117 17.2196C9.33117 17.4096 8.96117 17.5296 8.69117 17.4896L7.49117 17.3296C7.09117 17.2796 6.73117 16.8996 6.67117 16.5096L6.51117 15.3096C6.47117 15.0496 6.60117 14.6796 6.78117 14.4896L9.36117 11.9096C8.92117 10.4796 9.26117 8.85965 10.3912 7.72965C12.0112 6.10965 14.6512 6.10965 16.2812 7.72965C17.9012 9.33965 17.9012 11.9796 16.2812 13.6096Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.4516 16.2799L9.60156 15.4199",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.3945 10.7002H13.4035",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }